import { render, staticRenderFns } from "./items-table.vue?vue&type=template&id=0730b694&scoped=true"
import script from "./items-table.vue?vue&type=script&lang=js"
export * from "./items-table.vue?vue&type=script&lang=js"
import style0 from "./items-table.vue?vue&type=style&index=0&id=0730b694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0730b694",
  null
  
)

export default component.exports